import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';

import {
  ChangeEventTypeGroupDto,
  ChangeEventTypeGroupStore,
  EventTypeGroupDto
} from '../../../../../stores/configuration/events-n-requests/event-type-group-store';
import { nameof } from '../../../../../utils/object';

interface ChangeEventTypeGroupViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  changeEventTypeGroup?: ChangeEventTypeGroupStore;
  currentEventTypeGroup: EventTypeGroupDto;
}

// tslint:disable-next-line:no-empty-interface
interface ChangeEventTypeGroupViewState {}

@connect(['changeEventTypeGroup', ChangeEventTypeGroupStore])
class ChangeEventTypeGroupView extends React.Component<ChangeEventTypeGroupViewProps, ChangeEventTypeGroupViewState> {
  private get changeEventTypeGroupStore() {
    return this.props.changeEventTypeGroup;
  }

  constructor(props: ChangeEventTypeGroupViewProps) {
    super(props);

    this.changeEventTypeGroupStore.state.result = null;

    this.changeEventTypeGroupStore.change({
      id: this.props.currentEventTypeGroup.id,
      name: this.props.currentEventTypeGroup.name
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: ChangeEventTypeGroupViewProps) {
    if (this.changeEventTypeGroupStore.state.result && this.changeEventTypeGroupStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onChangeItem() {
    this.changeEventTypeGroupStore.update();
  }

  @autobind
  private onCancelChangeItem() {
    this.changeEventTypeGroupStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.changeEventTypeGroupStore.change({ ...this.changeEventTypeGroupStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelChangeItem} closeOnDimmerClick={false}>
        <Dimmer active={this.changeEventTypeGroupStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('Edit Delivery Type')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.changeEventTypeGroupStore.state.result && !this.changeEventTypeGroupStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.changeEventTypeGroupStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.changeEventTypeGroupStore.state.item && (
              <Form loading={this.changeEventTypeGroupStore.state.isBusy}>
                <Form.Field>
                  <Form.Input
                    required
                    fluid
                    label={t('Delivery Type')}
                    placeholder={t('Name')}
                    value={this.changeEventTypeGroupStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<ChangeEventTypeGroupDto>('name'), value)}
                  />
                </Form.Field>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelChangeItem}>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onChangeItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(ChangeEventTypeGroupView);
